export default __webpack_public_path__ + "3eaf17341edd3c4613f92e62dfbccfcf.svg";